import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const NotFound = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#131313] text-white p-4">
      <div className="text-center">
        <h1 className="text-5xl font-bold text-[#FFCA20] mb-4">404</h1>
        <h2 className="text-2xl mb-4">Page Not Found</h2>
        <p className="text-gray-400 mb-6">
          The page you are looking for doesn't exist or has been moved.
        </p>
        <button
          onClick={() => navigate(`/${user?.role}/dashboard`)}
          className="bg-[#FFCA20] hover:bg-yellow-600 text-black font-medium py-2 px-6 rounded"
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default NotFound;
